// extracted by mini-css-extract-plugin
export default {"PriceMarker":"PriceMarker_PriceMarker__NDcxZ","PriceMarker__marker":"PriceMarker_PriceMarker__marker__MzQ3N"};